import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesFiscal() {
  const { user } = useContext(AuthContext);
  const SECCIONES = [
    { section: "Comprobantes", items: [
      { label: "Facturas", icon: "fas fa-file-invoice-dollar", color: "#3b82f6", href: "/ListadoFacturas", desc: "Facturas fiscales", enabled: !!user.facturasFiscal },
      { label: "Complementos Pagos", icon: "fas fa-money-bill-wave", color: "#10b981", href: "/ListadoComplementosPago", desc: "Complementos de pago", enabled: !!user.compPagosFiscal },
      { label: "Notas de Credito", icon: "fas fa-money-check-alt", color: "#f59e0b", href: "/ListadoNotasCredito", desc: "Notas de credito", enabled: !!user.notasCreditoFiscal },
      { label: "Devoluciones", icon: "fas fa-undo-alt", color: "#ef4444", href: "/ListadoDevolucionesFiscal", desc: "Devoluciones fiscales", enabled: !!user.devolucionesFiscal },
    ]},
    { section: "Configuracion", items: [
      { label: "Registrar FIEL", icon: "fas fa-file-alt", color: "#6366f1", href: "/RegistrarEmpresas", desc: "Registrar empresas", enabled: !!user.menu_fiscal },
      { label: "Estado Cuenta", icon: "fas fa-file-invoice-dollar", color: "#06b6d4", href: "/EstadoCuentaK", desc: "Estado de cuenta", enabled: !!user.menu_fiscal },
    ]},
  ];
  return (
    <MenuBotones titulo="Fiscal" descripcion="Facturacion y comprobantes fiscales" icono="fas fa-file-invoice-dollar" color="#3b82f6" secciones={SECCIONES} />
  );
}

export default BotonesFiscal;
